import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AdminLayout } from '../layouts/AdminLayout';
import { PublicLayout } from '../layouts/PublicLayout';
import { PublicProjectsListPage } from '../../features/public/pages/PublicProjectsListPage';
import { PublicProjectDetailPage } from '../../features/public/pages/PublicProjectDetailPage';
import { RequireAuth } from './RequireAuth';
import { RequireRole } from './RequireRole';
import { AdminEndpointsPage } from '../../features/admin/pages/AdminEndpointsPage';
import { AdminLoginPage } from '../../features/admin/pages/AdminLoginPage';
import { AdminProjectsListPage } from '../../features/admin/pages/AdminProjectsListPage';
import { AdminProjectEditPage } from '../../features/admin/pages/AdminProjectEditPage';
import { AdminJsonEditorPage } from '../../features/admin/pages/AdminJsonEditorPage';
import { AdminUsersPage } from '../../features/admin/pages/AdminUsersPage';
import NotFoundPage from '../../features/shared/pages/NotFoundPage';
import {AdminProjectCreatePage} from "../../features/admin/pages/AdminProjectCreatePage";
import ConfigurationPage from '../../features/admin/pages/ConfigurationPage';

export function AppRoutes() {
    return (
        <BrowserRouter
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
            }}
        >
            <Routes>
                <Route element={<PublicLayout />}>
                    <Route index element={<PublicProjectsListPage />} />
                    <Route path="proyectos/:slug" element={<PublicProjectDetailPage />} />
                </Route>
                <Route
                    path="/administracion"
                    element={
                        <RequireAuth>
                            <AdminLayout />
                        </RequireAuth>
                    }
                >
                    <Route index element={<AdminProjectsListPage/>} />
                    <Route path="proyectos" element={<AdminProjectsListPage />} />
                    <Route
                        path="proyectos/nuevo"
                        element={<RequireRole allow={['ADMIN']}><AdminProjectCreatePage /></RequireRole>}
                    />

                    <Route
                        path="proyectos/:slug"
                        element={<RequireRole allow={['ADMIN', 'LECTOR']}><AdminProjectEditPage /></RequireRole>}
                    />
                    <Route
                        path="proyectos/:projectSlug/editor-json/:jsonSlug"
                        element={
                            <RequireRole allow={['ADMIN', 'LECTOR']}>
                                <AdminJsonEditorPage />
                            </RequireRole>
                        }
                    />
                    <Route path="usuarios" element={<RequireRole allow={['ADMIN']}><AdminUsersPage /></RequireRole>} />
                    <Route path="endpoints" element={<AdminEndpointsPage />} />
                    <Route path="configuracion" element={<RequireRole allow={['ADMIN']}><ConfigurationPage /></RequireRole>} />
                </Route>

                <Route path="/administracion/iniciar-sesion" element={<AdminLoginPage />} />
                <Route path="/administracion/*" element={<Navigate to="/administracion" replace />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </BrowserRouter>
    );
}
